import { createContext, useContext, ReactNode } from 'react';

interface FlowContextValue {
  boardId: string | null;
  boardName: string | null;
}

const FlowContext = createContext<FlowContextValue>({
  boardId: null,
  boardName: null,
});

interface FlowProviderProps {
  children: ReactNode;
  boardId: string | null;
  boardName: string | null;
}

export function FlowProvider({ children, boardId, boardName }: FlowProviderProps) {
  return (
    <FlowContext.Provider value={{ boardId, boardName }}>
      {children}
    </FlowContext.Provider>
  );
}

export function useFlowContext() {
  return useContext(FlowContext);
}
